import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Constants } from 'src/app/helper/constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private httpClient: HttpClient) { }

  getBlobSASToken =
    (containerName: string, files: string[]): Observable<{ url: string }[]> =>{
      return this.httpClient.post<{ path: string, url: string }[]>(
        Constants.GET_FILE,
        { containerName, paths: files }
      );
    }

}
